<div class="container">
  <p class="list-label">{{'admin.toolMaintenancePlans.plans.modal.activities' | translate}}</p>
  <div *ngFor="let group of overviewItems">
    <div class="group-container">
      <div class="header">
        <div class="tool-container">
          <i class="fa fa-cog" aria-hidden="true"></i>
          <p class="tools-label">{{'admin.tickets.create-modal.overview.tools-label' | translate}}</p> 
          <app-tooltip type="info"
                       class="tooltip"
                       [displayType]="'tools'"
                       [record]="computeNames(group)">
          </app-tooltip>
        </div>
        <p class="plan" (click)="goToClicked(group)">{{'admin.tickets.create-modal.overview.go-to-plan' | translate }}</p>
      </div>
      <div class="content">
        <app-maintenance-accordion [items]="group.items" [readonly]="true"></app-maintenance-accordion> 
      </div>
    </div>
  </div>
</div>